export default __webpack_public_path__ + "static/media/mercosul-logo.8e3eaa0d.svg";